import './admin-list.scss';
import '../../applicants/applicants.scss';
import {useQueryAdmins} from "../../../../api/admin/useQueryAdminsList";
import Loading from "../../../../components/UI/Loading/Loading";
import UserProfile from "../../../../components/UI/Profile/UserProfile";
import Toggle from "../../../../components/UI/Toggle/Toggle";
import Search from "../../../../components/UI/Search/Search";
import {useState} from "react";
import ComplexSearch from "../../../../components/UI/ComplexSearch/ComplexSearch";
import {adminsSortingOptions} from "../../../../constants/ui/sortingOptions";
import {ISortingOption} from "../../../../components/UI/SearchAndSort/SearchAndSort";
import {useMutateActiveAdmin} from "../../../../api/admin/useMutateActiveAdmin";

const AdminList = () => {
  const [searchPar, setSearchPar] = useState<string>('');
  const [sortPar, setSortPar] = useState<ISortingOption>(adminsSortingOptions[0]);
  const [hideInactive, setHideInactive] = useState<boolean>(false);
  const {data} = useQueryAdmins({
    search_term: searchPar,
    sorting_type: sortPar.value,
    hide_inactive: hideInactive
  });

  const {mutate} = useMutateActiveAdmin();

  const toggleActiveAdmin = (id: string, active: boolean) => {
    mutate({admin_id: id, is_active: !active});
  }

  console.log('data', data)
  return <div className={'admin-list'}>
    <div className={'admin-list-title'}>
      Admin list
    </div>

    <Search
      value={searchPar}
      onChange={(e) => setSearchPar(e.target.value)}
    />
    <ComplexSearch
      sorting={{
        options: adminsSortingOptions,
        value: sortPar,
        onChange: setSortPar
      }}
      toggle={[{
        active: hideInactive,
        onToggle: () => setHideInactive(!hideInactive),
        label: 'Hide inactive'
      }]}
    />

    <table className="admin-list-table">
      <thead>
      <tr>
        <th scope="col">First name</th>
        <th scope="col">Last name</th>
        <th scope="col">Email</th>
        <th scope="col">Change admins status</th>
      </tr>
      </thead>
      <tbody>
      {data?.data?.admins?.map((item: any) => (
        <tr
          key={item.user_id}
          className={item.highlight ? 'highlight-row' : ''}
        >
          <td className={'admin-list-table-name'}>
            <UserProfile
              name={{
                first_name: item.first_name,
                last_name: "",
              }}
              size="small"
              showText
            />
          </td>
          <td>
            {item.last_name}
          </td>
          <td>
            {item.email}
          </td>
          <td>
            <Toggle
              active={item.is_active}
              onToggle={() => toggleActiveAdmin(item.admin_id, item.is_active)}
              label={item.is_active ? 'Active' : 'Inactive'}
            />
          </td>
        </tr>
      ))}
      </tbody>
    </table>
  </div>
}

export default AdminList;